/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Hagridv1Dependency } from '../models/Hagridv1Dependency';
import { Hagridv1Miscellanea } from '../models/Hagridv1Miscellanea';
import { Hagridv1SystemStat } from '../models/Hagridv1SystemStat';
import { HttpFile } from '../http/http';

export class Hagridv1Checks {
    'systemStat'?: Hagridv1SystemStat;
    'dependencies'?: Array<Hagridv1Dependency>;
    'miscellaneous'?: Array<Hagridv1Miscellanea>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "systemStat",
            "baseName": "systemStat",
            "type": "Hagridv1SystemStat",
            "format": ""
        },
        {
            "name": "dependencies",
            "baseName": "dependencies",
            "type": "Array<Hagridv1Dependency>",
            "format": ""
        },
        {
            "name": "miscellaneous",
            "baseName": "miscellaneous",
            "type": "Array<Hagridv1Miscellanea>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Hagridv1Checks.attributeTypeMap;
    }

    public constructor() {
    }
}

